export const HEADER_TEXTS = {
  competitor_name: 'Competitors',
};
